module.exports = __webpack_public_path__ + "img/DE05875.fff2d5d7.png";